// src/Assets/Components/Footer.js

import './Footer.css';

const Footer = () => {
  return (
    <footer className='footer'>
      <div className='footer-text'>
        Powered by <a className='footer-link' href='https://react.dev/'>ReactApp</a> and <a className='footer-link' href='https://firebase.google.com/'>Firebase</a>.
      </div>
    </footer>
  );
};

export default Footer;
